<template>
<div>
  <MobileNavigation></MobileNavigation>
  
      <div class="mt-5">
        <select name="attendanceOrLeaves" id="attendanceOrLeaves" @change="onChange">
          <option value="attendance" selected="selected">Attendance</option>
          <option value="leaves">Leaves</option>
        </select>
      </div>

    <!-- Attendance Block - START -->
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-slate-900" style="height:100%" id="attendanceContainer">
      <div class="grid grid-cols-3 gap-1">
        <div class="bg-green-300 p-2">
          <span class="text-xl font-weight-bold">123</span><br>
          <span class="text-sm text-gray-600">Some Text</span>
        </div>
        <div class="bg-green-300 p-2">
          <span class="text-xl font-weight-bold">123</span><br>
          <span class="text-sm text-gray-600">Some Text</span>
        </div>
         <div class="bg-green-300 p-2">
          <span class="text-xl font-weight-bold">123</span><br>
          <span class="text-sm text-gray-600">Some Text</span>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-1 mt-1">
        <div class="text-center text-white bg-indigo-500">
          START DATE
        </div>
        
        <div class="text-center text-white bg-indigo-500">
          END DATE
        </div>
      </div>

      <div class="mt-1">
       <div>
        <table>
          <thead class="bg-white">
            <tr class="border-b-1">
              <th class="p-1">DATE</th>
              <th class="p-1">IN</th>
              <th class="p-1">OUT</th>
              <th class="p-1">E-Type</th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr class="border-t-1">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            <tr class="border-t-1 ">
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
              <td class="p-1">some text</td>
            </tr>
            
          </tbody>
        </table>
      </div>
      </div>
    </div>   
    <!-- Attendance Block - END -->

    <!-- Leaves Block - START -->
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-slate-900" style="height:100%" id="leavesContainer">
      <div class="grid grid-cols-3 gap-1">
        <div class="bg-green-300 p-2">
          <span class="text-xl font-weight-bold">Total</span><br>
          <span class="text-sm text-gray-600">00</span>
        </div>
        <div class="bg-green-300 p-2">
          <span class="text-xl font-weight-bold">Used</span><br>
          <span class="text-sm text-gray-600">00</span>
        </div>
         <div class="bg-green-300 p-2">
          <span class="text-xl font-weight-bold">Available</span><br>
          <span class="text-sm text-gray-600">00</span>
        </div>
      </div>

      <div class="p-2">
        <span class="text-2xl font-weight-bold mt-2">Leaves</span><br>
        <div>
          <div class="bg-white shadow rounded-lg border mt-1">
            <div class="p-2 grid grid-cols-2 gap-1">
              <h3 class="text-2xl font-weight-bold">Holi</h3>
              <h3 class="text-lg text-right">Days:12</h3>
            </div>
            <span class="p-2 text-xl">Sick</span> <br>
            <p class="text-lg text-white bg-green-500 pl-2 pr-2" >Accepted</p>
          </div>
        </div>
      </div>
    </div> 
    <!-- Leaves Block - END -->
  </div>
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }

    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }

    #attendanceOrLeaves{
     margin-bottom: 10px;
     border-radius: 10px;
     margin-left: 10px;
     margin-top: 10px;
    }

.border-t-1{
    border-top: 1px solid gray;
}
#container {
  width: 100%;
  height: 100%;
  margin-top: 20%;
/* --- FLEX --- */
  display: flex;
  justify-content: center;
  align-items: center;
}

.menu-box {
  width: 100%;
  height: 100%;
  font-size: 20px;
  color: #333;
  text-align: center;
  border-radius: 3px;
  display: inherit;
  justify-content: inherit;
  align-items: inherit;
  transition: all 0.5s ease;
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }

    </style>

<script>
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'
import MobileNavigation from "@/Layouts/MobileNavigation.vue";


export default {
  props: ["sessions"],

  components: {
    Welcome,
    PageTitle,
    JetNavLink,
    MobileNavigation,
  },
  data() {
    return {
      title: "Attendance Summary",
      username: null,
      password: null,

    };
  },
  methods: {
     onChange(event){

       if (event.target.value==='leaves'){
          document.getElementById('attendanceContainer').style.display = "none";
          document.getElementById('leavesContainer').style.display = "block";
          // getLeavesData();

       }else if (event.target.value==='attendance'){
          document.getElementById('attendanceContainer').style.display = "block";
          document.getElementById('leavesContainer').style.display = "none";
          // getAttendanceData();
       }
      //  console.log(event.target.value);
    }
,
    initView() {
      document.getElementById('attendanceContainer').style.display = "block";
      document.getElementById('leavesContainer').style.display = "none";
      
      document.getElementById("mobile-menu-checkbox").checked = false;
      closeDrawer();
      alert("hello");
    },
     closeDrawer() {
        // document.getElementById("mobile-menu-checkbox").checked = false;
        alert("hello");
    }
  },
  mounted() {
    this.initView();
  },
};
</script>
